import { useEffect, useState } from 'react';
import { runtimePreferences } from '../settings/runtime-preferences';
export function useStudioAutoplay() {
  const [enabled, setEnabled] = useState(() => runtimePreferences()?.autoplay === true);
  useEffect(() => {
    const update = () => setEnabled(runtimePreferences()?.autoplay === true);
    document.addEventListener('steos:settings', update);
    return () => document.removeEventListener('steos:settings', update);
  }, []);
  return enabled;
}
